export default __webpack_public_path__ + "static/media/dividendFocus_screenshot.fa8cb94c.png";